export const getOrderItems = (order) => {
	return order.shipping?.order_items?.length
		? order.shipping?.order_items
		: order.order_items;
};
